import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, OnInit } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MgService } from 'src/app/services/mg.service';
import { BusinessUser } from 'src/app/models/business-user.model';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { Call } from 'src/app/models/call.model';

@Component({
  selector: 'app-open-call-without-register',
  templateUrl: './open-call-without-register.component.html',
  styleUrls: ['./open-call-without-register.component.scss']
})
export class OpenCallWithoutRegisterComponent implements OnInit {
  public entryEditor = ClassicEditor;
  public loading: boolean = false;
  public registered: boolean = true;
  public user: BusinessUser;
  public form: UntypedFormGroup;
  public status: 'W' | 'P' | 'S' | 'E';
  public call: Call;

  constructor(
    private api: MgService,
    private fb: UntypedFormBuilder,
    private snackbar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.status = 'W';
    this.form = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
      name: [null, Validators.required],
      type: ["I", Validators.required],
      mobile: [null, Validators.required],
      description: [null, Validators.required],
      password: [null, Validators.required],
    })
  }

  public searchUser() {
    if(!this.form.controls.email.valid) return;

    this.loading = true;
    this.api.searchBusinessUser(this.form.value.email)
      .subscribe(
        res => {
          if(res != null){
            this.registered = true
            this.user = res.data
          } else {
            this.registered = false
          }
          this.loading = false
        },
        err => {
          this.registered = false
          this.loading = false
        },
      )
  }

  public submit() {
    if(!this.form.value.email) return this.snackbar.open('Informe o seu email.', 'Fechar');
    if(!this.form.value.description) return this.snackbar.open('Informe o seu problema.', 'Fechar');
    if(!this.registered && !this.form.value.name) return this.snackbar.open('Informe o seu nome.', 'Fechar');
    if(!this.registered && !this.form.value.mobile) return this.snackbar.open('Informe o seu telefone.', 'Fechar');
    if(!this.registered && !this.form.value.password) return this.snackbar.open('Informe o sua senha.', 'Fechar');

    this.status = 'P';
    this.api.postCallWithoutRegister(this.form.value)
      .subscribe(
        res => {
          this.status = 'S';
          this.call = res.data;
          this.snackbar.open('Chamado criado com sucesso!', 'Fechar')
          this.form.disable();
          this.form.reset();
        },
        err => this.status = 'E',
      )
  }

}
